import { render, staticRenderFns } from "./dimension_frame.vue?vue&type=template&id=d9386864&"
import script from "./dimension_frame.vue?vue&type=script&lang=js&"
export * from "./dimension_frame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports